import module from 'finanzas/module.js'

module.service('FinancesPosicionbancariaPrestamos', FinancesPosicionbancariaPrestamos)

const schema = {
  capital: 'number',
  destinatario_importe: 'number',
  destinatario_id_moneda: 'number',
  destinatario_tipo_cambio: 'number',
  fecha: 'date',
  fecha_pago: 'date',
  financiamiento: {
    capital: 'number',
    fecha: 'date',
    importe: 'number',
    indice: 'number',
    interes: 'number',
  },
  id_moneda: 'number',
  importe: 'number',
  interes: 'number',
  interes_porcentaje: 'number',
  tipo_cambio: 'number',
}

function FinancesPosicionbancariaPrestamos ($http) {
  this.get = function (idEmpresa, idCuenta, fechaInicial, fechaFinal) {
    return $http.get('/api/empresa/cuenta/prestamos', {
      params: {
        id_empresa: idEmpresa,
        id_cuenta: idCuenta,
        fecha_inicial: fechaInicial && fechaInicial.toYMD(),
        fecha_final: fechaFinal && fechaFinal.toYMD(),
      },
      schema,
    })
  }

  this.post = function (idEmpresa, idCuenta, data) {
    return $http.post('/api/empresa/cuenta/prestamos', data, {
      params: {
        id_empresa: idEmpresa,
        id_cuenta: idCuenta,
      },
      schema,
      clearCache: 'finances',
    })
  }
}



// WEBPACK FOOTER //
// ./src/finanzas/services/Finances/Posicionbancaria/Prestamos.js